import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { AIWidget } from '@/ui/components/ai-widget/ai-widget'

export const AIChatLauncher = forwardRef<
  HTMLButtonElement,
  { onOpen: () => void; isHidden?: boolean }
>(function AIChatLauncher({ onOpen, isHidden = false }, ref) {
  const { t } = useTranslation()
  return (
    <button
      ref={ref}
      type="button"
      onClick={onOpen}
      aria-label={t('configuration_chat.open')}
      // Stays mounted while hidden so closing the panel can restore focus to it.
      aria-hidden={isHidden || undefined}
      tabIndex={isHidden ? -1 : undefined}
      className={`group fixed bottom-6 right-6 z-40 flex items-center justify-center rounded-full outline-none transition-opacity duration-200 focus-visible:ring-2 focus-visible:ring-[#a2eeff] ${
        isHidden ? 'pointer-events-none opacity-0' : 'opacity-100'
      }`}
    >
      {/* Hover brightens the glow via opacity — scaling the button would upscale
          this blurred (filtered, GPU-composited) layer and soften the icon. */}
      <span
        className="absolute -inset-1.5 animate-aurora-spin rounded-full bg-[conic-gradient(from_0deg,#1790ff,#10fab8,#a2eeff,#7a67f0,#1790ff)] opacity-70 blur-md transition-opacity duration-300 group-hover:opacity-100 motion-reduce:animate-none"
        aria-hidden="true"
      />
      <span className="relative">
        <AIWidget />
      </span>
    </button>
  )
})
